import { api } from "./client";

/** Shape of GET /api/translations/ — both languages, namespaced. */
export type TranslationsDocument = {
  en: Record<string, Record<string, string>>;
  ru: Record<string, Record<string, string>>;
};

export async function getTranslations(): Promise<TranslationsDocument> {
  const { data } = await api.get<TranslationsDocument>("/api/translations/");
  return data;
}
